import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'errorPage.404.title' }),
    description: translate({ id: 'errorPage.404.description' }),
    primaryAction: translate({ id: 'errorPage.404.primaryAction' }),
    secondaryAction: translate({ id: 'errorPage.404.secondaryAction' }),
  }))

  return api
}
